import React, { useState } from "react";

import formStructure from "./constants/formStructure";
import Form from "./form";

import { ContainerStyledWrapper, AccordionContent } from "./container.style";
import useAppContext from "../../../../../hooks/useAppContext";
import useToast from "../../../../../hooks/useToast";

const Container = () => {
  const { axios } = useAppContext();
  const displayToast = useToast();
  const [serverErrors, setServerErrors] = useState(null);
  const [responseMessage, setResponseMessage] = useState(null);

  const onSubmit = (data) => {
    setServerErrors(null);
    axios
      .post("admin/support_tools/solver", data)
      .then((resp) => {
        setResponseMessage(resp.data.data.message);
        displayToast({
          success: true,
          message: "Request proceed successfully!",
        });
      })
      .catch((err) => {
        setServerErrors(err.response.data.data.errors);
        displayToast({ success: false, message: "Something went wrong..." });
      });
  };

  return (
    <ContainerStyledWrapper>
      {responseMessage && (
        <AccordionContent>{responseMessage}</AccordionContent>
      )}
      <Form
        onPostForm={onSubmit}
        structure={formStructure}
        serverErrors={serverErrors}
      />
    </ContainerStyledWrapper>
  );
};

export default Container;
